import {Injectable} from "@angular/core";
import {EventBus} from "../../event/EventBus";
import {UserModelInitializedEvent} from "../../event/UserModelEvents";
import {UserModelService} from "../usermodel/usermodel.service";
import {PointsChangedEvent, PointCounterEvent} from "../../event/StepEvents";
import {SubscriptionBase} from "../../base/SubscriptionBase";
import {filter} from "rxjs/operators";

@Injectable()
export class PointService extends SubscriptionBase {

    private currentPts: number = 0;
    private startingPts: number = 0;

    constructor(private eventBus:EventBus, private userModelService:UserModelService) {
        super("PointsService");

        this.eventBus.pipe(filter(event => event instanceof PointsChangedEvent)).subscribe((e: PointsChangedEvent) => {
            this.propagatePoints();
        });

        this.eventBus.pipe(filter(event => event instanceof UserModelInitializedEvent)).subscribe((e: UserModelInitializedEvent) => {
            this.propagatePoints();
        });
    }

    private propagatePoints(): void {
        // this is called when the user model is updated (user may have earned points), and/or points have
        // been earned in a step.
        this.startingPts = this.currentPts;
        this.currentPts = this.userModelService.totalPoint;
        this.eventBus.next(new PointCounterEvent("update", this.userModelService.totalPoint));
    }

    public currentPoints(): number {
        return this.currentPts;
    }

    public startingPoints(): number {
        return this.startingPts;
    }

    public setLibraryPoints(newPts: number): void {
        // do not want to count up thousands of points from zero on entering the library for
        // the first time in a session.  This is basically just to make sure the correct value is showing.
        this.startingPts = newPts;
        this.currentPts = newPts;
        this.eventBus.next(new PointCounterEvent("update", newPts));
    }
}

